/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventContent } from './EventContent';
import {
    EventContentFromJSON,
    EventContentFromJSONTyped,
    EventContentToJSON,
    EventContentToJSONTyped,
} from './EventContent';
import type { Case } from './Case';
import {
    CaseFromJSON,
    CaseFromJSONTyped,
    CaseToJSON,
    CaseToJSONTyped,
} from './Case';

/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    type?: EventTypeEnum;
    /**
     * 
     * @type {Array<EventContent>}
     * @memberof Event
     */
    content?: Array<EventContent>;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof Event
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    tenantId?: string;
    /**
     * 
     * @type {Case}
     * @memberof Event
     */
    securityCase?: Case;
}


/**
 * @export
 */
export const EventTypeEnum = {
    Note: 'note',
    CaseCreated: 'case_created',
    CaseAssigned: 'case_assigned',
    CaseEscalated: 'case_escalated',
    CaseClosed: 'case_closed',
    CaseReopened: 'case_reopened',
    CaseFeedback: 'case_feedback',
    CaseResolved: 'case_resolved',
    StatusChange: 'status_change',
    Feedback: 'feedback',
    CaseUpdated: 'case_updated',
    CaseOwnerChanged: 'case_owner_changed',
    CaseSeverityChanged: 'case_severity_changed',
    CaseEscalationCleared: 'case_escalation_cleared',
    Comment: 'comment'
} as const;
export type EventTypeEnum = typeof EventTypeEnum[keyof typeof EventTypeEnum];


/**
 * Check if a given object implements the Event interface.
 */
export function instanceOfEvent(value: object): value is Event {
    return true;
}

export function EventFromJSON(json: any): Event {
    return EventFromJSONTyped(json, false);
}

export function EventFromJSONTyped(json: any, ignoreDiscriminator: boolean): Event {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(EventContentFromJSON)),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'securityCase': json['securityCase'] == null ? undefined : CaseFromJSON(json['securityCase']),
    };
}

export function EventToJSON(json: any): Event {
    return EventToJSONTyped(json, false);
}

export function EventToJSONTyped(value?: Event | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(EventContentToJSON)),
        'createdBy': value['createdBy'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'tenantId': value['tenantId'],
        'securityCase': CaseToJSON(value['securityCase']),
    };
}

